import ReactSelect from './ReactSelect'

export default ReactSelect
